<template>
  <div class="multiDropdown dropdown">
    <button
      class="dropdown-button"
      @click="active = !active"
      :class="{ 'transparent-button': transparent }"
    >
      <awesomeIcon icon="sort" /> {{ displayPrefix }} ({{ selected.length }})
    </button>
    <transition name="fade">
      <div class="dropdown-bg" v-if="active" @click="active = false"></div>
    </transition>
    <transition name="fade">
      <div class="dropdown-body" :class="{
        'scrollable': scroll,
        'align-right': align === 'right',
      }">
        <ul class="dropdown-list" v-if="active">
          <li
            class="dropdown-deselect"
            @click="clear()"
          >
            <span :class="selected.length ? '' : 'grey'">
              Alle ({{ selected.length }}) actieve verwijderen
            </span>
          </li>
          <li
            v-for="(item, index) in array"
            :key="index"
            @click="select(item)"
            :class="{ 'disabled': !item.label && !item.value }"
            :title="(selected.indexOf(item.value) > -1) ? 'Verwijderen' : 'Toevoegen'"
          >
            <div class="dropdown-checkbox checkbox-green">
              <awesomeIcon :icon="selected.includes(`${item.value}`)
                ? 'check-square'
                : 'fa-regular fa-square'
              "/>
            </div>
            <span
              v-if="item.label || item.value"
              :class="selected.includes(`${item.value}`) ? 'checkbox-green' : ''"
            >
              {{ item.label ? item.label : item.value }}
            </span>
            <span v-else/>
            <span
              v-if="item.rightLabel"
              class="right-label"
              :class="selected.includes(`${item.value}`) ? 'checkbox-green' : ''"
            >
              {{ item.rightLabel }}
            </span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'MultiDropdown',
  emits: ['update:model-value'],
  props: {
    array: {
      type: Array,
      default: () => [],
    },
    cb: {
      type: Function,
      default: () => { },
    },
    modelValue: {
      type: String,
    },
    displayPrefix: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    scroll: {
      type: Boolean,
      default: false,
    },
    filterName: {
      type: String,
      default: '',
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: '',
    },
    filterComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
      lastSelected: null,
      selected: [],
    };
  },
  created() {
    if (!this.selected.length && this.defaultValue && this.defaultValue.length) {
      this.selected = this.defaultValue;
    }
  },
  watch: {
    modelValue() {
      this.selected = [];
      if (this.modelValue) {
        this.selected = this.modelValue.split(',');
      }
    },
  },
  methods: {
    clear() {
      // null of lege array
      this.$emit('update:model-value', '');
      if (this.$parent.get) {
        this.$parent.get();
      }
    },
    select(item) {
      if (item === undefined || item === null || (item !== null && !('label' in item) && !('value' in item) && item.rightLabel)) {
        return;
      }
      if (this.selected.indexOf(`${item.value}`) > -1) {
        this.selected.splice(this.selected.indexOf(`${item.value}`), 1);
      } else {
        this.selected.push(`${item.value}`);
      }
      this.$emit('update:model-value', this.selected.join(','));
      if (this.$parent.get) {
        this.$parent.get();
      }
      this.$nextTick(() => {
        if (this.cb) {
          this.cb(this.selected);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.multiDropdown {
  padding: 0;
  vertical-align: top;
  width: auto !important;

  button {
    border-radius: 0;
    white-space: nowrap;
    padding: 10px;

    &.transparent-button {
      background-color: transparent;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .dropdown-body {
    width: auto;
    height: auto;
    position: absolute;
    z-index: 99;
    border-radius: 6px;
    overflow: hidden;

    &.align-right {
      right: 0px;
    }

    &.scrollable {
      max-height: 300px;
      overflow-y: scroll;
    }

    ul {
      display: table;
      min-width: 80px;
      position: relative;
      border-radius: 0;

      li {
        white-space: nowrap;
        display: flex;
        align-items: center;
        padding-left: 15px;
        position: relative;
        user-select: none;

        .dropdown-checkbox {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;

          &.checkbox-green {
            color: #59b300;
          }

          svg {
            font-size: 13px;
          }
        }

        &.disabled {
          cursor: default;
          background-color: transparent;
        }

        &:last-child span.right-label {
          cursor: text;
        }

        span.right-label {
          color: rgba(#000, 0.5);
          margin-left: 15px;
        }
      }
    }
  }
}
</style>
